import { render, staticRenderFns } from "./ESG.vue?vue&type=template&id=2065846e&scoped=true"
import script from "./ESG.vue?vue&type=script&lang=js"
export * from "./ESG.vue?vue&type=script&lang=js"
import style0 from "./ESG.vue?vue&type=style&index=0&id=2065846e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2065846e",
  null
  
)

export default component.exports